const animationSelector = '.js-animations-in-viewport';
const activeClassName = 'animations-in-viewport--active';

export function initAnimationsInViewport() {
    const elements = document.querySelectorAll(animationSelector);

    if (!elements.length) {
        return;
    }

    if (!('IntersectionObserver' in window)) {
        elements.forEach((element) => {
            element.classList.add(activeClassName);
        });

        return;
    }

    const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            entry.target.classList.add(activeClassName);
            observerInstance.unobserve(entry.target);
        });
    }, {
        threshold: 0.65,
    });

    elements.forEach((element) => {
        observer.observe(element);
    });
}
